export default {
  editProfile: '/settings/editProfile',
  changeAppPassword: '/settings/changePassword',
  sensorSettings: '/settings/sensor',
  settings: '/settings',
  termsOfUse: '/settings/termsOfUse',
  privacyPolicy: '/settings/privacyPolicy',
  incomeReport: '/settings/incomeReport',
};
